import { EventEmitter, Injectable, Output } from '@angular/core';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends RestApiService{
  currentLoginCount: any;
  apiUrl = ApiUrlConstant.apiUrl;
  ePragnaUrl = ApiUrlConstant.ePragnaUrl;
  @Output() logoutEvent: EventEmitter<any> = new EventEmitter();
  login(obj:any,countryCode:string): Observable<any> {
    // console.log(obj);
    const body: any = 
      {
        "isdCode": countryCode,
        "phone": obj.phone
      }  
    if(obj.password) {
      body.password = obj.password;
    } else {
      body.userOtp = obj.otp;
    }
    body.userActivityTrackingDataDto = obj?.userActivityTrackingDataDto;
    const url = this.apiUrl + `/api/authentication/login`;
    const headers = { 
      "X-Page": obj?.userActivityTrackingDataDto?.data?.page || "WEB_IL_SITE",
      "X-Product": "1",
     }
    console.log(url)
    return this.post(url, body, headers);
  }

  loginAdmissionNumber(body:any): Observable<any> {
    const url = this.apiUrl + `/api/authentication/loginWithAdmissionNumber`;
    return this.post(url, body);
  }
  loginAdmissionNumberNew(body:any): Observable<any> {
    const newUrl = this.ePragnaUrl + '/authentication';
    return this.post(newUrl, body);
  }
  logout() {
    const url = this.apiUrl + `/api/authentication/invalidate`;
    return this.post(url);
  }
  logoutSriChaitanya() {
    const url = this.ePragnaUrl + '/authenticationlogout';
    return this.post(url);
  }

  getAddressList(userId){
    const url =  this.apiUrl + `/api/v1.1/users/`+userId+`/address`;
    return this.get(url);
  }

  saveUserAddress(userId,body){
    const url = this.apiUrl + `/api/v1.1/users/`+userId+`/address`;
    return this.post(url,body);
  }

  updateUserAddress(addressId,body){
    const url = this.apiUrl + `/api/v1.1/users/`+addressId+`/address`;
    return this.put(url,body);
  }

  updateUsershippingAddress(shippingaddressId,body){
    const url = this.apiUrl + `/api/v1.1/users/address?userShippingAddressId=${shippingaddressId}`;
    return this.put(url,body);
  }
  deleteAddress(addressId,body){
    const url = this.apiUrl + `/api/v1.1/users/`+addressId+`/address`;;
    return this.delete(url,body);
  }
}
